module.exports = __webpack_public_path__ + "assets/TBisectAngle.b44c0ba5469d982889cca1ff673ee1c0.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TBisectAngle.gmt
// module id = 1008
// module chunks = 0